'use strict';

export function setUpTouchControls(pikaVolley) {

  if (!isMobileDevice()) {
  return; 
  }


  const style = document.createElement('style');
  style.innerHTML = `
    .touch-controls {
      position: fixed;
      bottom: 20px;
      left: 20px;
      right: 20px;
      height: 150px;
      z-index: 9999;
      display: flex;
      justify-content: space-between;
      align-items: center;
      pointer-events: none; 
      touch-action: none;
      user-select: none;
      -webkit-user-select: none;
    }

   
    .joystick-base {
      pointer-events: auto;
      position: relative;
      width: 120px;
      height: 120px;
      background: rgba(255, 255, 255, 0.1);
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      backdrop-filter: blur(2px);
    }

 
    .joystick-knob {
      width: 50px;
      height: 50px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 50%;
      position: absolute;
      transform: translate(0, 0);
      transition: transform 0.1s; 
      box-shadow: 0 4px 10px rgba(0,0,0,0.3);
    }
    

    .joystick-knob.active {
      transition: none;
      background: rgba(253, 167, 106, 0.8); 
    }


    .btn-action {
      pointer-events: auto;
      width: 90px;
      height: 90px;
      background: rgba(255, 60, 60, 0.3);
      border: 2px solid rgba(255, 60, 60, 0.5);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-weight: bold;
      font-size: 28px;
      font-family: sans-serif;
      box-shadow: 0 4px 10px rgba(0,0,0,0.3);
      backdrop-filter: blur(2px);
    }
    
    .btn-action:active {
      background: rgba(255, 60, 60, 0.7);
      transform: scale(0.95);
    }
  `;
  document.head.appendChild(style);


  const container = document.createElement('div');
  container.className = 'touch-controls';
  container.innerHTML = `
    <div class="joystick-base">
      <div class="joystick-knob"></div>
    </div>
    
    <div class="btn-action" data-key="power">Z</div>
  `;
  document.body.appendChild(container);


  const player1Keyboard = pikaVolley.keyboardArray[0];
  const joystickBase = container.querySelector('.joystick-base');
  const joystickKnob = container.querySelector('.joystick-knob');
  const actionBtn = container.querySelector('.btn-action');


  const handleAction = (isPressed) => {
    player1Keyboard.powerHitKey.isDown = isPressed;
  };
  actionBtn.addEventListener('touchstart', (e) => { e.preventDefault(); handleAction(true); });
  actionBtn.addEventListener('touchend', (e) => { e.preventDefault(); handleAction(false); });
  

  actionBtn.addEventListener('mousedown', () => handleAction(true));
  actionBtn.addEventListener('mouseup', () => handleAction(false));


  const maxDistance = 35; 
  const deadZone = 10;    

  const handleJoystickMove = (touchX, touchY) => {
    const rect = joystickBase.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;


    let dx = touchX - centerX;
    let dy = touchY - centerY;
    const distance = Math.sqrt(dx * dx + dy * dy);


    let visualDx = dx;
    let visualDy = dy;
    
    if (distance > maxDistance) {
      const ratio = maxDistance / distance;
      visualDx *= ratio;
      visualDy *= ratio;
    }


    joystickKnob.style.transform = `translate(${visualDx}px, ${visualDy}px)`;
    joystickKnob.classList.add('active');


    player1Keyboard.rightKey.isDown = dx > deadZone;
    player1Keyboard.leftKey.isDown = dx < -deadZone;
    player1Keyboard.downKey.isDown = dy > deadZone;
    player1Keyboard.upKey.isDown = dy < -deadZone;
  };

  const handleJoystickEnd = () => {

    joystickKnob.style.transform = `translate(0px, 0px)`;
    joystickKnob.classList.remove('active');
    

    player1Keyboard.leftKey.isDown = false;
    player1Keyboard.rightKey.isDown = false;
    player1Keyboard.upKey.isDown = false;
    player1Keyboard.downKey.isDown = false;
  };

  joystickBase.addEventListener('touchstart', (e) => {
    e.preventDefault();
    handleJoystickMove(e.touches[0].clientX, e.touches[0].clientY);
  });

  joystickBase.addEventListener('touchmove', (e) => {
    e.preventDefault();
    handleJoystickMove(e.touches[0].clientX, e.touches[0].clientY);
  });

  joystickBase.addEventListener('touchend', (e) => {
    e.preventDefault();
    handleJoystickEnd();
  });
  
  joystickBase.addEventListener('touchcancel', (e) => {
    e.preventDefault();
    handleJoystickEnd();
  });
}

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}